import { createFileRoute } from '@tanstack/react-router'
import { AiUsagePage } from '@/pages/AiUsagePage'

const AiUsageRoute = () => {
  return <AiUsagePage />
}

export const Route = createFileRoute('/ai-usage')({
  component: AiUsageRoute,
})
